module.exports = __webpack_public_path__ + "img/root000.a6c63396.png";